var map = {
	"./App": "xYwX",
	"./App.jsx": "xYwX",
	"./Editorial/Editorial": "SRdu",
	"./Editorial/Editorial.jsx": "SRdu",
	"./Editorial/Editorial.scss": "v3IE",
	"./Elements/Button/Button": "CwcU",
	"./Elements/Button/Button.jsx": "CwcU",
	"./Elements/Button/Button.scss": "4gwF",
	"./Elements/Checkbox/Checkbox": "DLGd",
	"./Elements/Checkbox/Checkbox.jsx": "DLGd",
	"./Elements/Checkbox/Checkbox.scss": "B/bj",
	"./Elements/FakeSelect/FakeSelect": "mkyd",
	"./Elements/FakeSelect/FakeSelect.jsx": "mkyd",
	"./Elements/FakeSelect/FakeSelect.scss": "8s1T",
	"./Elements/Input/Input": "jHNd",
	"./Elements/Input/Input.jsx": "jHNd",
	"./Elements/Input/Input.scss": "riYQ",
	"./Elements/Radio/Radio": "l+Hx",
	"./Elements/Radio/Radio.jsx": "l+Hx",
	"./Elements/Radio/Radio.scss": "Eivg",
	"./Elements/Select/Select": "qN6N",
	"./Elements/Select/Select.jsx": "qN6N",
	"./Elements/Select/Select.scss": "T8fd",
	"./Elements/TextBackgrounds/TextBackgrounds": "nJmO",
	"./Elements/TextBackgrounds/TextBackgrounds.jsx": "nJmO",
	"./Footer/Footer": "s4cb",
	"./Footer/Footer.jsx": "s4cb",
	"./Footer/Footer.scss": "64fX",
	"./Header/Header": "Xhe4",
	"./Header/Header.jsx": "Xhe4",
	"./Header/Header.scss": "pr76",
	"./Header/Notification": "xg2N",
	"./Header/Notification.jsx": "xg2N",
	"./Header/Notification.scss": "Mrf/",
	"./Index/Index": "0YD/",
	"./Index/Index.jsx": "0YD/",
	"./Index/Index.scss": "xWWl",
	"./Page/Page": "+4EV",
	"./Page/Page.jsx": "+4EV",
	"./Page/Page.scss": "ml7l",
	"./Switcher": "bcPK",
	"./Switcher.jsx": "bcPK",
	"./Templates/BackgroundMedia/BackgroundMedia": "BTkN",
	"./Templates/BackgroundMedia/BackgroundMedia.jsx": "BTkN",
	"./Templates/BackgroundMedia/BackgroundMedia.scss": "Lohu",
	"./Templates/Button/Button": "MJgw",
	"./Templates/Button/Button.jsx": "MJgw",
	"./Templates/EditorialLink/EditorialLink": "yDYh",
	"./Templates/EditorialLink/EditorialLink.jsx": "yDYh",
	"./Templates/EditorialLink/EditorialLink.scss": "TzDw",
	"./Templates/Embed/Embed": "0x2a",
	"./Templates/Embed/Embed.jsx": "0x2a",
	"./Templates/Embed/Embed.scss": "EQMK",
	"./Templates/Heading/Heading": "hnIk",
	"./Templates/Heading/Heading.jsx": "hnIk",
	"./Templates/Heading/Heading.scss": "Ps+a",
	"./Templates/Image/Image": "eifF",
	"./Templates/Image/Image.jsx": "eifF",
	"./Templates/Image/Image.scss": "LkpZ",
	"./Templates/Paragraph/Paragraph": "T0hq",
	"./Templates/Paragraph/Paragraph.jsx": "T0hq",
	"./Templates/Paragraph/Paragraph.scss": "unjF",
	"./Templates/Product/Product": "ZrvV",
	"./Templates/Product/Product.jsx": "ZrvV",
	"./Templates/Product/Product.scss": "iaXD",
	"./Templates/Separator/Separator": "By69",
	"./Templates/Separator/Separator.jsx": "By69",
	"./Templates/Separator/Separator.scss": "moDU",
	"./Templates/Spacer/Spacer": "S/nj",
	"./Templates/Spacer/Spacer.jsx": "S/nj",
	"./Templates/Spacer/Spacer.scss": "Dfjq",
	"./Templates/TemplateParser": "Djad",
	"./Templates/TemplateParser.jsx": "Djad",
	"./Templates/TemplateParser.scss": "5cCJ",
	"./Templates/Video/Video": "BjCw",
	"./Templates/Video/Video.jsx": "BjCw",
	"./Templates/Video/Video.scss": "0DCv",
	"./Templates/VideoEmbed/VideoEmbed": "JYug",
	"./Templates/VideoEmbed/VideoEmbed.jsx": "JYug",
	"./Templates/VideoEmbed/VideoEmbed.scss": "HzcL",
	"./Top/Top": "7su/",
	"./Top/Top.jsx": "7su/",
	"./UniversalComponent": "IO1V",
	"./UniversalComponent.jsx": "IO1V"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "jdtg";
module.exports = webpackContext;